import type { UnifiedAppData } from "../unifiedDataSchema";
import { CorruptRecord } from "./types";

/** Each section of UnifiedAppData except gameHistory is one state record. */
export const STATE_SECTIONS = [
  "user",
  "stats",
  "achievements",
  "collections",
  "wordCollections",
  "dailyChallenges",
  "currentGames",
  "ariadne",
  "meta",
] as const;
export type StateSection = (typeof STATE_SECTIONS)[number];

/** State record set once the legacy blob has been copied and verified. */
export const MIGRATED_MARKER = "migrated";

/** Each state section serialized: the record value and the change detector. */
export const sectionJson = (data: UnifiedAppData): [StateSection, string][] =>
  STATE_SECTIONS.map((s) => [s, JSON.stringify(data[s])]);

/** A decoded record object (not an array, not a CorruptRecord). */
export const isPlainObject = (v: unknown): v is Record<string, unknown> =>
  Object.prototype.toString.call(v) === "[object Object]" &&
  !(v instanceof CorruptRecord);
